import {
  SET_APP_LANGUAGE,
  SET_USER_PROFILE,
  SET_ACC_CLASS,
  SET_FEATURE_LIST,
  SET_INVOICE_NUMBER,
  SET_MENU_LIST,
  SET_LOGIN_DETAILS
} from '../utils/constants'

const initialState = {
  language: 'en',
  accClass: '',
  profile: {},
  featureList: {},
  invoiceNumber:'',
  menuList: {},
  loginDetails: {}
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_APP_LANGUAGE:
      return { ...state, language: payload }
    case SET_ACC_CLASS:
      return { ...state, accClass: payload }
    case SET_USER_PROFILE:
      return { ...state, profile: payload }
    case SET_FEATURE_LIST:
      return { ...state, featureList: payload }
    case SET_INVOICE_NUMBER:
      return { ...state, invoiceNumber: payload }
    case SET_LOGIN_DETAILS:
      return { ...state, loginDetails: payload }
    case SET_MENU_LIST:
      return { ...state, menuList: payload }
    default:
      return state
  }
}
